<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <LuAgency
                label="Agency"
                return-object
                :items="availableAgencies"
                v-model="selectedUserAgency.Agency"
                :rules="[(v) => !!v || 'required']"
              ></LuAgency>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuAgencyRole
                return-object
                label="Agency Role"
                v-model="selectedUserAgency.AgencyRole"
                :rules="[(v) => !!v || 'required']"
              ></LuAgencyRole>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveUserAgencyDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuAgency from '@components/select/single/LuAgencyObject'
import LuAgencyRole from '@components/select/single/LuAgencyRoleObject'
import { authMethods, authComputed } from '@state/helpers'
import UserAgency from '@classes/UserAgency'
//templateTODO: import lookup components you plan to use
export default {
  components: { LuAgency, LuAgencyRole },
  data: () => ({
    dialog: false,
    valid: true,
    selectedUserAgency: new UserAgency(),
    modalText: '',
  }),
  props: {
    selectedUserID: {
      type: Number,
      required: true,
    },
    selectedAgencyID: {
      type: Number,
    },
  },
  created() {
    this.loadLuAgencies()
  },
  computed: {
    ...authComputed,
    ...get('userAgency', ['saving']),
    ...get('luAgency', ['luAgencies']),
    availableAgencies() {
      if (this.isSuperUser) {
        return null
      } else {
        return this.userAdminAgencies
      }
    },
  },
  methods: {
    loadLuAgencies: call('luAgency/loadLuAgencies'),
    handleError: call('errors/handleError'),
    ...call('userAgency', ['saveUserAgency']),
    async validate() {
      this.$refs.form.validate()
    },
    editUserAgency(entry) {
      this.selectedUserAgency = new UserAgency(entry)
      this.modalText = 'Edit User Agency'
      this.dialog = !this.dialog
    },

    addUserAgency() {
      this.modalText = 'Insert User Agency'
      this.selectedUserAgency = new UserAgency({ UserID: this.selectedUserID })
      if (this.selectedAgencyID && this.selectedAgencyID > 0) {
        this.selectedUserAgency.AgencyID = this.selectedAgencyID
        this.selectedUserAgency.Agency = this.luAgencies.find(
          (a) => a.ID == this.selectedAgencyID
        )
      }
      this.dialog = !this.dialog
    },
    saveUserAgencyDetails() {
      this.validate().then(() => {
        if (this.valid) {
          this.selectedUserAgency.AgencyID = this.selectedUserAgency.Agency.ID
          this.selectedUserAgency.AgencyRoleID =
            this.selectedUserAgency.AgencyRole.ID
          if (this.selectedUserID > 0) {
            this.saveUserAgency(this.selectedUserAgency.removeRelated()).then(
              (res) => {
                this.$emit('refresh')
                this.selectedUserAgency = new UserAgency()
                this.$refs.form.resetValidation()
              },
              (err) => {}
            )
          } else this.$emit('newUserAgency', this.selectedUserAgency)
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedUserAgency = new UserAgency()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
